import type { LanguageLevel } from "../types/extra";

/**
 * German language proficiency levels
 * Centralized to avoid duplication across components
 */
export const LANGUAGE_LEVELS: LanguageLevel[] = [
	"A1 - Anfänger",
	"A2 - Grundlegende Kenntnisse",
	"B1 - Fortgeschrittene Kenntnisse",
	"B2 - Selbstständige Kenntnisse",
	"C1 - Fachkundige Kenntnisse",
	"C2 - Muttersprachliche Kenntnisse (oder annähernd muttersprachlich)",
];